var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.39434 3.69162C4.02145 3.38745 6.3119 2.21947 8.06432 0.96875H13.9355C15.6879 2.21947 17.9783 3.38745 20.6055 3.69162C20.7199 3.70447 20.8255 3.75909 20.902 3.84502C20.9786 3.93094 21.0207 4.0421 21.0203 4.15719V12.4871C21.0203 18.1361 15.2854 22.883 10.9999 24.0312C6.71446 22.883 0.979495 18.1361 0.979495 12.4871V4.15719C0.979112 4.0421 1.02125 3.93093 1.09781 3.84501C1.17437 3.75908 1.27997 3.70446 1.39434 3.69162ZM2.3857 4.96559V12.4871C2.3857 13.1256 2.47443 13.7585 2.63896 14.375C3.60731 18.0038 7.43076 21.4545 10.9994 22.5672C13.2337 21.8672 15.493 20.244 17.011 18.5326C18.4905 16.8646 19.6141 14.7642 19.6141 12.4871V4.96559C17.4148 4.5688 15.3449 3.63153 13.4943 2.375H8.50551C6.65498 3.63153 4.58503 4.5688 2.3857 4.96559ZM3.3232 5.72745V12.4871C3.3232 13.0434 3.40143 13.5961 3.54478 14.1333C4.40929 17.3732 7.83904 20.48 10.9986 21.5799C12.9642 20.8913 14.9531 19.4398 16.3096 17.9105C17.6318 16.4198 18.6766 14.5261 18.6766 12.4871V5.72745C16.7258 5.26597 14.884 4.4142 13.2098 3.3125H8.78999C7.11585 4.4142 5.27399 5.26597 3.3232 5.72745ZM12.5016 7.17186H9.49832C9.4362 7.17198 9.37666 7.19672 9.33273 7.24064C9.2888 7.28457 9.26407 7.34411 9.26395 7.40623V9.78275H6.88743C6.82531 9.78287 6.76577 9.80761 6.72184 9.85153C6.67791 9.89546 6.65318 9.955 6.65306 10.0171V13.0203C6.65306 13.1494 6.75834 13.2547 6.88743 13.2547H9.26395V15.6312C9.26395 15.7603 9.36923 15.8656 9.49832 15.8656H12.5016C12.6307 15.8656 12.7359 15.7603 12.7359 15.6312V13.2547H15.1124C15.2415 13.2547 15.3468 13.1494 15.3468 13.0203V10.0171C15.3468 9.88803 15.2415 9.78275 15.1124 9.78275H12.7359V7.40623C12.7358 7.34411 12.7111 7.28457 12.6671 7.24064C12.6232 7.19672 12.5637 7.17198 12.5016 7.17186Z",
    fill: "url(#paint0_linear_6126_18605)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6126_18605",
    x1: 10.9999,
    y1: 0.96875,
    x2: 10.9999,
    y2: 24.0312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.e6d7b948b4d747951ebaf7c77015c24e.svg";
export { ForwardRef as ReactComponent };